import React, { useState, useEffect, useRef } from 'react';
//import logo from './logo.png';
//import downloadOnAppStore from './downloadOnAppStore.svg'
import './App.css';

import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { Box, useMediaQuery } from '@mui/material';
import PlayerComponent from './components/PlayerComponent/PlayerComponent.lazy';
import makeTheme from './makeTheme';
import { SpinnerCircular } from 'spinners-react';

const API_BASEURL = 'https://api.countingsheep.v6v.one';
const APP_APPSTORE_URL = 'https://apps.apple.com/us/app/counting-sheep-bedtime-stories/id6445967632';
const APP_DISPLAY_NAME = 'Counting Sheep';

function App() {
  const [mode /*, setMode*/] = useState('system');
  const [story, setStory] = useState(null);
  const [apiError, setApiError] = useState(null);

  const isDark = useMediaQuery('(prefers-color-scheme: dark)');

  const params = new URLSearchParams(window.location.search);
  const invitationId = params.get('i');
  const paramsValid = invitationId !== null;
  console.log('paramsValid', paramsValid, invitationId);
  let fetchingData = useRef(false);

  useEffect(() => {
    async function fetchData() {
      try {
        const s = await getStory(invitationId);
        //const logoUrl = (new URL(logo, document.baseURI)).href
        setStory(s);
        document.title = s.name;
        fetchingData.current = false;

        window.gtag('event', 'share_story_opened_web', {
          item_id: s.storyId,
          item_name: s.name,
          invitation_id: invitationId,
          screen_name: 'ShareStoryWeb'
        });
      } catch (err) {
        setApiError(err.message);
        fetchingData.current = false;
      }
    }
    if (paramsValid && fetchingData.current === false && !story && !apiError) {
      fetchingData.current = true;
      console.log('fetchData()');
      fetchData();
    }
  }, [paramsValid, invitationId, story, apiError]);

  const theme = makeTheme(mode === 'system' ? (isDark ? 'dark' : 'light') : mode);

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          width: '100vw',
          height: '100vh',
          bgcolor: 'background.paper',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'top',
          alignItems: 'center',
          color: 'text.primary',
          textAlign: 'center'
        }}
      >
        <Box
          sx={{
            width: {
              xs: '100vw',
              sm: '80vw',
              lg: '70vw',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'top',
              alignItems: 'center',
              color: 'text.primary',
              textAlign: 'center'
            }
          }}
        >
          <div className="topContainer">
            {story && (
              <div className="Story-Cover">
                <img src={story.imageUrl} alt={story.name} />
              </div>
            )}
            <div className="App-Slogan">
              <Box sx={{ typography: 'h5' }}>You have been invited!</Box>
            </div>
            <a href={APP_APPSTORE_URL}>
              <img src="logo.png" className="App-logo" alt={APP_DISPLAY_NAME + ' Logo'} />
            </a>
          </div>

          {paramsValid === false && <div className="error">Invalid parameters. Please check your link.</div>}

          {apiError && (
            <div className="error">
              An error occurred fetching your invitation:
              <br />
              {apiError}
            </div>
          )}

          {story && (
            <div class="Story-Container">
              <h2>{story.name}</h2>
              <p className="description">{story.description}</p>
            </div>
          )}

          <div className="imageRowContainer">
            <a href={APP_APPSTORE_URL}>
              <img src="icon.png" className="AppIcon" alt="App Icon" />
            </a>
            <a href={APP_APPSTORE_URL}>
              <img src="downloadOnAppStore.svg" className="AppStoreDownload" alt="Download on AppStore" />
            </a>
          </div>
        </Box>

        <SpinnerCircular color="#999999" enabled={paramsValid && !apiError && !story} />

        <PlayerComponent story={story} />
      </Box>
    </ThemeProvider>
  );
}

async function getStory(invitationId) {
  console.log('window.story', window.story);
  if (window.story) {
    console.log('using prefetched story');
    return window.story;
  }
  const url = `${API_BASEURL}/v1/invitation/${invitationId}`;

  const response = await fetch(url);
  if (response.ok) {
    return await response.json();
  } else {
    console.log('fetch error', await response.text());
    return null;
  }
}

export default App;
